import { render } from "./BaseButton.vue?vue&type=template&id=205acc95&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=205acc95&lang=scss"
import "./BaseButton.vue?vue&type=style&index=1&id=205acc95&scoped=true&lang=css"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205acc95"]])

export default __exports__